<template>
  <div class="main-condition-title-div">
    <span class="title-span">{{ contentTitle }}</span>
    <a-button
      v-if="filterStatus"
      class="margin-left-16"
      @click="handleCheck"
    >
      <i
        class="iconfont iconicon-test20 icon-color  icon-space"
        :class="{iconColors:checkParams?true:false}"
      /><span class="text">{{ $t('message["960"]') }}</span>
    </a-button>
    <a-button
      v-if="exportStatus"
      @click="handleFetchGetExportLinkUrl"
    >
      <i class="iconfont iconicon-test22 icon-color icon-space" /><span class="text"> {{ $t('message["185"]') }}</span>
    </a-button>
    <span
      v-if="selectSourceStatus"
      class="select-span"
    >
      <a-cascader
        :options="options"
        class="origin-cascader"
        :placeholder="refferPlaceholder"
        allow-clear
        @change="onChange"
      />
    </span>
    <!-- 1.0.5迭代新增[分类筛选器] -->
    <span
      v-if="typeSelectStatus"
      class="select-span"
    >
      <!-- <a-select
        style="width: 120px"
        :default-value="0"
        :value="typeDefault"
        @change="handleChangeType"
      >
        <a-select-option
          v-for="item in staticType"
          :key="item.id"
          :value="item.id"
        >{{ item.name }}</a-select-option>
      </a-select> -->
      <a-select
        v-if="staticTypeList['info_type'] && staticTypeList['info_type'].length > 0"
        default-value="0"
        style="width: 120px"
        :value="typeDefault"
        @change="handleChangeType"
      >
        <div
          slot="dropdownRender"
          slot-scope="menu"
          class="select-extend"
          :style="{'padding-top': typePaddingTop}"
        >
          <v-nodes :vnodes="menu" />
          <div
            v-if="staticTypeList['info_sign'] && staticTypeList['info_sign_status'] !== -7"
            class="ant-select-dropdown-menu extend-checkbox-menu"
          >
            <a-checkbox-group
              v-model="recordTypeVal"
              @change="handleChangeSign"
            >
              <div
                v-for="item in staticTypeList['info_sign']"
                :key="item.id + 'c'"
                class="ant-select-dropdown-menu-item"
              >
                <a-checkbox :value="item.id + ''">
                  {{ item.name }}
                </a-checkbox>
              </div>
            </a-checkbox-group>
          </div>
        </div>
        <template v-if="staticTypeList['info_type']">
          <a-select-option
            v-for="item in staticTypeList['info_type']"
            :key="item.id"
            :value="item.id"
          >{{ item.name }}</a-select-option>
        </template>
      </a-select>
    </span>
    <span
      v-if="selectStatus"
      class="select-span"
    >
      <a-select
        default-value="-1"
        style="width: 120px"
        @change="handleChange"
      >
        <a-select-option value="-1">{{ $t('message["905"]') }}</a-select-option>
        <a-select-option
          v-for="item in levelList"
          :key="item.id"
          :value="item.id"
        >{{ item.name }}</a-select-option>
      </a-select>
    </span>
    <!-- 信息来源选择 -->
    <span
      v-if="selectFromInfoStatus"
      class="select-span"
    >
      <a-select
        style="width: 120px"
        default-value="0"
        @change="handleFromChange"
      >
        <a-select-option value="0">{{ $t('message["906"]') }}</a-select-option>
        <a-select-option
          v-for="item in fromSelectData"
          :key="item.fieldkey"
          :value="item.fieldkey"
          :title="item.fieldname"
        >{{ item.fieldname }}</a-select-option>
      </a-select>
    </span>
    <!--  -->
    <span class="date-range-span">
      <a-range-picker
        class="date-picker"
        :value="dateValue"
        @change="dateTimeChange"
      />
    </span>
    <!--  -->
    <span
      v-for="(item,index) in dateData"
      :key="index"
      class="date-span-default"
      :class="{activeDate:dateSelectIndex===index}"
      @click="handleSelect(item,index)"
    >
      {{ item.value }}
      <!-- :style="{width:(item.value.length===3?'58px':'58px')}" -->
    </span>
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
export default {
  components: {
    VNodes: {
      functional: true,
      render: (h, ctx) => ctx.props.vnodes
    }
  },
  props: {
    contentTitle: {
      type: String,
      default: ''
    },
    dateData: {
      type: Array,
      default: () => []
    },
    exportParams: {
      type: Object,
      default: () => { }
    },
    defaultSelectIndex: {
      type: Number,
      default: 0
    },
    selectStatus: {
      type: Boolean,
      default: false
    },
    selectSourceStatus: {
      type: Boolean,
      default: false
    },
    selectFromInfoStatus: {
      type: Boolean,
      default: false
    },
    selectData: {
      type: Array,
      default: () => { }
    },
    filterStatus: {
      type: Boolean,
      default: false
    },
    exportStatus: {
      type: Boolean,
      default: false
    },
    typeSelectStatus: {
      type: Boolean,
      default: false
    },
    typeDefault: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      dateSelectIndex: 4,
      options: [],
      dateValue: [],
      recordTypeVal: [],
      infoType: 0
    }
  },
  computed: {
    ...mapState('statistic', ['levelList', 'checkParams', 'messageSourceList', 'indexExportLinkUrl', 'staticType', 'fromSelectData']),
    ...mapGetters('statistic', ['staticTypeList']),
    refferPlaceholder () {
      return this.$t('message["887"]')
    },
    staticSignLen () {
      const { info_sign: infoSign = [] } = this.staticTypeList
      return infoSign.length
    },
    typePaddingTop () {
      const len = this.staticSignLen
      const { info_sign_status: infoSignStatus = 0 } = this.staticTypeList
      let pdTop = 0
      if (infoSignStatus !== -7) {
        if (len === 2) {
          pdTop = '80px'
        } else if (len === 1) {
          pdTop = '40px'
        } else {
          pdTop = 0
        }
      } else {
        pdTop = 0
      }
      return pdTop
    }
  },
  watch: {
    messageSourceList (val) {
      this.options = this.formateMessageSourceData(val)
    },
    indexExportLinkUrl (val) {
      if (val) {
        this.exportIndexDatas(val)
      }
    }
  },
  mounted () {
    this.dateSelectIndex = this.defaultSelectIndex
    // console.log(this.contentTitle, this.dateSelectIndex)
    this.fetchGetLevelList()
    this.fetchGetMessageSource()
  },
  methods: {
    ...mapMutations('statistic', ['setCheckVisible']),
    ...mapActions('statistic', ['fetchGetLevelList', 'fetchGetMessageSource', 'fetchGetExportLinkUrl']),
    handleSelect (value, index) {
      this.dateSelectIndex = index
      this.dateValue = []
      this.$emit('callbackEvent', value)
    },
    handleCheck () {
      this.setCheckVisible(true)
    },
    initdDteSelectIndex () {
      this.dateSelectIndex = -1
    },
    handleChange (val) {
      this.$emit('level-change', val)
    },
    onChange (val) {
      this.$emit('infoFromOrigin', val)
    },
    handleFetchGetExportLinkUrl () {
      this.fetchGetExportLinkUrl(this.exportParams)
    },
    exportIndexDatas (url) {
      window.location.href = url
    },
    dateTimeChange (date, dateString) {
      this.dateValue = date
      this.$emit('dateTimeChange', dateString)
    },
    // 信息来源数据
    formateMessageSourceData () {
      const array = this.messageSourceList
      if (Array.isArray(array)) {
        array.map(value => {
          value['value'] = value.fieldkey
          value['label'] = value.fieldname
          value['children'] = []
          const objChild = value.child
          if (Object.keys(objChild).length > 0) {
            const objChildArray = Object.values(objChild)
            objChildArray.map(values => {
              value.children.push({
                value: values.fieldkey,
                label: values.fieldname
              })
            })
          }
        })
      }
      return array
    },
    // 选择分类
    handleChangeType (e) {
      const len = this.recordTypeVal.length
      const obj = len === 1 ? { info_type: e, info_sign: this.recordTypeVal[0] } : { info_type: e }
      this.infoType = e
      this.$emit('typeChange', obj)
    },
    // 信息来源选择
    handleFromChange (val) {
      this.$emit('handleFromChange', val)
    },
    handleChangeSign (val) {
      const len = val.length
      this.recordTypeVal = val
      const obj = len === 1 ? { info_type: this.infoType, info_sign: val[0] } : { info_type: this.infoType }
      this.$emit('typeChange', obj)
    }
  }
}
</script>
<style lang="scss">
.ant-btn {
  .text {
    top: 0px;
    position: relative;
  }
}
.date-range-span {
  float: right;
  .date-picker {
    .ant-calendar-picker-input {
      width: 280px;
    }
    width: 280px !important;
    margin-top: 8px !important;
    margin-left: 32px;
  }
}
.select-span {
  .origin-cascader {
    width: 280px !important;
  }
}
</style>

<style lang="scss" scoped>
@import '@/assets/css/statistic/style.scss';
.main-condition-title-div {
  height: 48px;
  border-top: solid 1px #ebebeb;
  background-color: #ffffff;
  .title-span {
    font-size: 18px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    width: 36px;
    height: 48px;
    line-height: 48px;
    letter-spacing: normal;
    text-align: center;
    color: #333333;
  }

  .threeLengthDefault {
    float: right;
    width: 58px;
    height: 24px;
    text-align: center;
    font-size: 14px;
    line-height: 24px;
    color: #333333;
    margin-left: 32px;
    letter-spacing: normal;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    margin-top: 11px;
    cursor: pointer;
    &:hover {
      width: 44px;
      height: 24px;
      border-radius: 12px;
      box-shadow: inset 0 1px 1px 0 rgba(255, 255, 255, 0.5);
      border: solid 1px #5077aa;
      background-image: linear-gradient(to top, #5077aa, #608fcc);
      color: #fff;
    }
  }
  .date-span-default {
    float: right;
    height: 24px;
    text-align: center;
    font-size: 14px;
    line-height: 22px;
    color: #333333;
    margin-left: 16px;
    margin-top: 13px;
    vertical-align: middle;
    cursor: pointer;
    padding:0  8px;
    &:hover {
      border-radius: 12px;
      border: solid 1px #5077aa;
      background-color: #5077aa;
      color: #fff;
      padding: 0 7px;
    }
  }
  .activeDate {
    height: 24px;
    line-height: 22px;
    border-radius: 12px;
    cursor: pointer;
    border: solid 1px #5077aa;
    background-color: #5077aa;
    color: #fff;
  }
  .export-btn {
    width: 48px;
    height: 16px;
    padding: 8px 12px 8px 8px;
    font-size: 14px;
    color: #333333;
    border-radius: 4px;
    border: solid 1px #ebebeb;
    background: rgba(245, 245, 245, 1);
    margin-left: 16px;
    cursor: pointer;
  }
  .select-span {
    margin-top: 8px;
    margin-left: 24px;
    float: right;
  }
  .select-span_other {
    margin-top: 8px;
    margin-left: 24px;
  }
}
.select-extend::v-deep {
  position: relative;
  // padding-top: 80px;
  .ant-checkbox-wrapper {
    margin-right: 0;
    margin-bottom: 0;
    width: 100%;
  }
  .ant-checkbox-group {
    width: 100%;
  }
  .extend-checkbox-menu {
    position: absolute;
    top: 0;
    border-bottom: 1px solid #ebebeb;
    padding-bottom: 4px;
    left: 0;
    right: 0;
  }
}
</style>
